import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import './tv.css';
import App from './App';
import { startTV } from './lib/tv';

// No axios interceptors: there is no session to attach or to expire. The API is
// open to anything that can reach the server, which is the point of putting
// Cloudflare Access in front of it rather than a login form inside it.

startTV();

// The service worker (public/sw.js) keeps the app shell on the device so a
// home-screen launch paints at once. Production only: in development it would
// serve yesterday's bundle over the dev server's. It never touches the API or
// video, and a reload is all an update takes - see sw.js.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production' && window.isSecureContext) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => registration.update())
      .catch(() => {
        // Without it the site works exactly as before
      });
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
